module.exports = __webpack_public_path__ + "media/student_loans/CASL_0423_Partner_Fastweb Ads_1200x820@2x-611ccd8b.png";